import Breadcrumbs from './breadcrumbs.element.js';

export default Breadcrumbs;

Breadcrumbs.define('wje-breadcrumbs', Breadcrumbs);
